import { REQUEST, RESPONSE, FAILURE, CLEAR } from '../../actions/blueprints/create';

const initialState = {
  data: null,
  isLoading: false,
  error: null
};

export default function blueprint_create(state = initialState, action) {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case RESPONSE:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case CLEAR:
      return initialState;
    default:
      return state;
  }
} 